import jQuery from 'jquery'
import Splide from "@splidejs/splide";
import videojs from 'video.js';

let splide1;
//let followupVideoIsPlaying = false;
//const customAnmation = new CustomAnimation();

const addChapterMarkers = (player, cues) => {
  const progressHolder = player.controlBar.progressControl.seekBar.el();

  Array.from(cues).forEach((cue) => {
    // Marker erstellen
    const marker = document.createElement('div');
    marker.className = 'vjs-chapter-marker';

    // Berechne die linke Position des Markers basierend auf der Videodauer
    marker.style.left = `${(cue.startTime / player.duration()) * 100}%`;

    // Tooltip erstellen
    const tooltip = document.createElement('div');
    tooltip.className = 'vjs-marker-tooltip';
    tooltip.innerText = cue.text; // Kapitelname als Tooltip
    marker.appendChild(tooltip);

    // Tooltip anzeigen/ausblenden
    marker.addEventListener('mouseenter', () => {
      tooltip.style.visibility = 'visible';
      tooltip.style.opacity = '1';
    });
    marker.addEventListener('mouseleave', () => {
      tooltip.style.visibility = 'hidden';
      tooltip.style.opacity = '0';
    });

    marker.addEventListener('click', (event) => {
      event.stopPropagation(); // Verhindert Weiterleitung des Klicks
      event.preventDefault(); // Ignoriert Standardverhalten
    });


    // Marker zur Fortschrittsleiste hinzufügen
    progressHolder.appendChild(marker);
  });
};

class Landingpage {
  init() {
    this.initPage();
    this.initCaroussel();
    //this.initVideo();
    this.initAccordion();
    this.onScroll();
    this.initCopyButton();
  }

  initPage = () => {

    // button action
    document.querySelectorAll('.button_landingpage').forEach(link => {



      link.addEventListener('click', function(e) {

        const href = this.getAttribute('href');

        // Wenn href vorhanden und nicht leer → normaler Link
        if (href && href.trim() !== '') {
          return;
        }

        // Sonst Modal öffnen
        e.preventDefault();

        const modalSelector = this.getAttribute('data-bs-target');
        jQuery(modalSelector).modal('show');
      });
    });
  }

  initCaroussel = () => {
    if(jQuery('.splide_01').length > 0) {
      splide1 = new Splide('.splide_01', {
        type: 'loop',
        perPage: 1,
        focus: 'center',
        autoplay: false,
        flickMaxPages: 3,
        updateOnMove: true,
        pagination: true,
        throttle: 300
      });

      splide1.mount();

      setTimeout(function () {
        splide1.refresh();
      }, 500);
    }
  }

  initVideo = () => {
    alert('initVideo');
    const player = videojs('followup_video', {
      controls: true,
      autoplay: false,
      loop: true,
      preload: 'auto',
      fluid: true,
    });

    player.ready(() => {
      //alert('initVideo.ready()');
      const track = Array.from(player.textTracks()).find((t) => t.kind === 'chapters');
      if (track) {
        track.mode = 'hidden'; // Kapitel-Infos JS-seitig aktivieren
        track.oncuechange = () => {
          const cues = track.cues;
          if (cues) {
            addChapterMarkers(player, cues);
          }
        };
      }
    });
  };

  initAccordion = () => {
    // Click-Handler für Accordion-Buttons
    $('.button_faq').click(function(e){
      e.preventDefault();
      $(this).next(".faq_content").slideToggle();

      // Toggle open-Klasse nur für das geklickte Element
      $(this).toggleClass('open');
    });

    // Alle Accordion-Elemente beim Start aufklappen
    $('.button_faq').each(function() {
      $(this).addClass('open');
      $(this).next('.faq_content').show(); // Direkt anzeigen ohne Animation
    });

  }

  initAccordionOld = () => {
    //alert('initAccordion');
    $('.button_faq').click(function(e){
      e.preventDefault();
      $(this).next(".faq_content").slideToggle();
      $(this).closest("li").siblings().find('.faq_content').slideUp();

      if( $(this).hasClass('open') ) {
        $('.button_faq').removeClass("open");
        $(this).removeClass('open')
      }
      else {
        $('.button_faq').removeClass("open");
        $(this).addClass('open')
      }
    });

    $('.faq_holder ul li:first-child .button_faq').addClass('button_faq_1');

    $('.button_faq_1').trigger('click');

  }

  initCopyButton = () =>  {
    // Copy Email Button
    const copyEmailButton = document.querySelector('.button_copy_email');
    if (copyEmailButton) {
      copyEmailButton.addEventListener('click', (e) => {
        e.preventDefault();

        const email = copyEmailButton.getAttribute('data-email');

        // Fallback-Methode für ältere Browser oder unsichere Kontexte
        const copyToClipboard = (text) => {
          // Erstelle ein temporäres Textarea-Element
          const textArea = document.createElement('textarea');
          textArea.value = text;
          textArea.style.position = 'fixed';
          textArea.style.left = '-9999px';
          textArea.style.top = '0';
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();

          try {
            // Versuche zu kopieren
            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);

            if (successful) {
              showSuccess();
            } else {
              //nsole.error('Kopieren fehlgeschlagen');
            }
          } catch (err) {
            //console.error('Fehler beim Kopieren:', err);
            document.body.removeChild(textArea);
          }
        };

        const showSuccess = () => {
          const originalText = copyEmailButton.textContent;

          copyEmailButton.textContent = 'Copied!';
          copyEmailButton.style.backgroundColor = '#F6FF00';
          copyEmailButton.style.borderColor = '#F6FF00';
          copyEmailButton.style.color = '#10002C';

          setTimeout(() => {
            copyEmailButton.textContent = originalText;
            copyEmailButton.style.backgroundColor = '';
            copyEmailButton.style.borderColor = '';
            copyEmailButton.style.color = '';
          }, 2000);
        };

        // Moderne Browser mit Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(email).then(() => {
            showSuccess();
          }).catch(() => {
            // Falls Clipboard API fehlschlägt, Fallback verwenden
            copyToClipboard(email);
          });
        } else {
          // Fallback für ältere Browser
          copyToClipboard(email);
        }
      });
    }

    // button action
    document.querySelectorAll('.button_landingpage').forEach(link => {

      link.addEventListener('click', function(e) {

        const href = this.getAttribute('href');

        // Wenn href vorhanden und nicht leer → normaler Link
        if (href && href.trim() !== '') {
          return;
        }

        // Sonst Modal öffnen
        e.preventDefault();

        const modalSelector = this.getAttribute('data-bs-target');
        jQuery(modalSelector).modal('show');
      });
    });
  }

  onScroll = () => {
    jQuery(window)
      .scroll(function () {
        let scrollPos = $(document).scrollTop();

        // header video
        if(scrollPos > 200) {
          //$('.home_video').get(0).pause();
        }
        else {
          //$('.home_video').get(0).play();
        }

      }).scroll();
  };
}

export default Landingpage;
